<template>
    <div v-if="isVisible" style="position: absolute; right: 2000px; width: 100%;">
        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 color="#F0000F"
                 :is-full-page="fullPage"></loading>
        <div class="bikes-list" v-for="(el, index) in bikesData" :key="index" ref="print" style="padding: 24px 24px">
            <div v-if="index == 0" style="width:100%; text-align: center">
                <h1 style="margin-bottom: 6px; font-size: 32px; text-transform: uppercase; padding-bottom: 14px;">Konfigurator doboru rowerów Kross</h1>
                <h2 style="font-size: 16px; color: #555555;">Oto najlepsze modele dla Ciebie</h2>
            </div>
            <div style="display: flex; flex-wrap: wrap; width: 100%;">
                <div class="bikes-list-el" v-for="(bike, index) in el" :key="bike.Id">
                    <div :class="['tile', { 'not-active': bike.StockQuantity <= 0 }]">
                        <div class="photo">
                            <img :src="bike.Photo" alt="Zdjęcie roweru" />
                        </div>
                        <div class="content">
                            <span class="info">{{ bike.CategoryCollection }}</span>
                            <h5 class="name">{{ bike.Name.toUpperCase() }}</h5>
                            <span class="price">{{ handlePriceFormat(bike.Price) }}</span>
                            <span class="availability" v-if="bike.StockQuantity > 0">Twój rozmiar {{ bike.Size }} jest dostępny!</span>
                            <span class="availability" v-else >Twój rozmiar {{ bike.Size }} jest niedostępny!</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import api from "@/axios.config.js";
    import jsPDF from 'jspdf';

    // Import component
    import Loading from 'vue-loading-overlay';
    // Import stylesheet
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
        name: "BikeTileList",
        data() {
            return {
                bikesData: [],
                isVisible: false,
                isLoading: false,
                fullPage: true
            };
        },
        methods: {
            show: function (e) {
                this.isVisible = true;
                this.isLoading = true;
                this.getBikesData(e);

            },
            getBikesData: function (e) {
                let globalThis = this;
                let resolve = []
                e.forEach(element => {
                    resolve.push(api.get("/products/getProduct", { params: { id: element } }))
                })
                Promise.all(resolve).then(values => {
                    globalThis.calculateData(values)                 
                })
            },
            handlePriceFormat: function (value) {
                var parts = value.toString().split(".");
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                parts.join(".");
                return parts + " zł";
            },
            calculateData: function (values) {
                let rawArray = values.map(function (el) {
                    return el.data
                });

                function* chunks(arr, n) {
                    for (let i = 0; i < arr.length; i += n) {
                        yield arr.slice(i, i + n);
                    }
                }

                this.bikesData = [...chunks(rawArray, 6)];
                this.printToPDFHandler()
            },
            async printToPDFHandler() {
                let globalThis = this;
                this.$nextTick(() => {
                    setTimeout(() => {
                        let area = globalThis.$refs.print;
                        this.printToPDF(area)
                    }, 0);
                })
            },
            async printToPDF(area) {
                /* eslint-disable */
                console.log('converting...');

                //var printableArea = this.$refs.print;
                var printableAreas = area;

                var pdf = new jsPDF('', 'pt', 'a4');
                let page = 0;
                for (const singleArea of printableAreas) {
                    let output = await this.$html2canvas(singleArea, {
                        useCORS: true,
                    })

                    var contentWidth = output.width;
                    var contentHeight = output.height;
                  
                    //a4 format [595.28,841.89]	      
                    var imgWidth = 595.28;
                    var imgHeight = 595.28 / contentWidth * contentHeight;

                    var pageData = output.toDataURL('image/jpeg', 1.0);

                    if (page > 0) {
                        pdf.addPage(); //8.5" x 11" in pts (in*72)
                    }
                    pdf.setPage(page + 1);
                    pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
                    page++
                }

                pdf.save('Kross ' + new Date().toLocaleString() + '.pdf');
                this.isLoading = false;
                this.isVisible = false;            
            },
        },
        components: {
            Loading
        },
    };
</script>